var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "min-h-screen" },
    [
      _c(
        "v-app-bar",
        {
          class: _vm.$vuetify.breakpoint.smAndUp ? "px-6" : null,
          attrs: {
            app: "",
            color: "white",
            height: "64",
            "elevate-on-scroll": "",
          },
        },
        [
          _c(
            "v-container",
            { staticClass: "flex items-center" },
            [
              _c(
                "a",
                { attrs: { href: "https://musicologielessons.com" } },
                [
                  _c("jet-application-logo", {
                    staticClass: "block w-auto",
                    class: _vm.$vuetify.breakpoint.xs ? "h-6" : "h-9",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex gap-2 justify-end" },
                [
                  _c(
                    "SoliBtn",
                    {
                      staticClass: "white--text",
                      attrs: { gradient: "gradient-orange", href: "/login" },
                    },
                    [_vm._v("Login")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-main",
        [
          _c(
            "v-container",
            [
              _c("p", [
                _vm._v(
                  "\n                Our clients opt-in by visiting go.musicologie.com or\n                musicologie.com/get-started and fill out our get started\n                form, including their phone number. Our form very clearly\n                states that they are opting- in to receive text messages\n                with opt-out instructions and that they are agreeing to\n                receive text messages by submitting the form. They are\n                additionally presented with our privacy policy, which\n                outlines our text message use and opt-out instructions in\n                more detail. Opt-out can occur by responding STOP to any of\n                our messages or by adjusting their communication preferences\n                in their profile within our website/app.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("v-img", {
                attrs: {
                  src: "/notification-preferences-example.png",
                  width: "400",
                },
              }),
              _vm._v(" "),
              _c("v-img", {
                attrs: { src: "/opt-in-example-no-check.png", width: "100%" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SiteFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }